import api from "./api";

const requireId = (id, name = "id") => {
    if (id === undefined || id === null || id === "") {
        throw new Error(`${name} is required`);
    }
    return id;
};

export const getMyOrders = async () => {
    const res = await api.get("/orders/my");
    return res.data;
};

export const getOrdersByClient = async (clientId) => {
    const id = requireId(clientId, "clientId");
    const res = await api.get(`/orders/client/${id}`);
    return res.data;
};

export const createOrder = async (data) => {
    const res = await api.post("/orders", data);
    return res.data;
};

export const getOrderById = async (id) => {
    const orderId = requireId(id, "orderId");
    const res = await api.get(`/orders/${orderId}`);
    return res.data;
};

export const cancelOrder = async (id) => {
    const orderId = requireId(id, "orderId");
    const res = await api.post(`/orders/${orderId}/cancel`);
    return res.data;
};

export default {
    getMyOrders,
    getOrdersByClient,
    createOrder,
    getOrderById,
    cancelOrder,
};